import reduceColorPointByRatio from '../../../common/utils/reduce-color-point-by-ratio';

const dark = (params) => {
  const { targetColor, backgroundColor, targetColorPalette } = params;
  const fallback = {
    rule: 'decoration.background.dark',
    params,
  };

  return reduceColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: (ratio) => ratio >= 1.5,
      fallback,
    },
    '900'
  );
};

export default dark;
